import { render } from "./QuoteListItem.vue?vue&type=template&id=2cfafeb2&scoped=true"
import script from "./QuoteListItem.vue?vue&type=script&lang=js"
export * from "./QuoteListItem.vue?vue&type=script&lang=js"

import "./QuoteListItem.vue?vue&type=style&index=0&id=2cfafeb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfafeb2"]])

export default __exports__